<template>
    <div class="card-connections kbWhite">
        <v-row style="position: relative">
            <template v-if="cardOptions.loading">
                <v-col class="text-center" cols="12">
                    <v-progress-circular indeterminate :color="cardOptions.color ? cardOptions.color : 'primary'"></v-progress-circular>
                </v-col>
            </template>
            <template v-else>
                <v-col cols="10" class="pt-0 pb-1">
                    <div class="header-info">
                        <div class="d-flex align-center">
                            <v-icon class="mr-2"
                                    :color="cardOptions.titleIcon.color"
                                    :size="cardOptions.titleIcon.size || '13px'"
                                    v-if="cardOptions.titleIcon && cardOptions.titleIcon.icon">
                                {{ cardOptions.titleIcon.icon }}
                            </v-icon>
                            <span class="kbSemiLightGrayText--text text-uppercase font-weight-medium"
                                style="font-size: 14px">
                                {{ cardOptions.title }}
                            </span>
                        </div>
                        <h3 class="kbDarkText--text ma-0 font-weight-medium">
                            {{ cardOptions.amount }}
                        </h3>
                        <div>
                            <span v-if="cardOptions.trends && cardOptions.trends.percentage !== undefined"
                                  :class="parseFloat(cardOptions.trends.percentage) > 0 ? 'kbGreen--text' : 'kbRed--text'">
                                {{ cardOptions.trends.percentage + '%' }}
                            </span>
                            <span v-if="cardOptions.trends && cardOptions.trends.percentage !== undefined" style="margin: 0 5px;"/>
                            <span v-if="cardOptions.trends && cardOptions.trends.range !== undefined">{{ cardOptions.trends.range }}</span>
                        </div>
                    </div>
                </v-col>

                <div v-if="cardOptions.trends && cardOptions.trends.percentage !== undefined" class="d-flex justify-center align-center"
                    :class="parseFloat(cardOptions.trends.percentage) > 0 ? 'kbGreen' : 'kbRed'"
                    style="position: absolute; right: 0; top: 0; border-radius: 50%; width: 40px; height: 40px">
                    <v-icon dark size="25px">{{ parseFloat(cardOptions.trends.percentage) > 0 ? 'mdi-trending-up' : 'mdi-trending-down' }}</v-icon>
                </div>

                <v-col cols="12" class="pb-0 pt-2" v-if="filteredItems.length > 0">
                    <ul class="pa-0 ma-0">
                        <li v-for="(item, index) in filteredItems"
                            :key="index"
                            style="list-style: none; line-height: 1.4">
                            <span class="kbGray--text my-0 text-capitalize font-weight-regular"
                                style="font-size: 14px">
                                {{ item.key }}<span v-if="item.value"> {{ item.value }}</span>
                            </span>
                        </li>
                    </ul>
                </v-col>
            </template>
        </v-row>
    </div>
</template>

<script>
export default {
  computed: {
    filteredItems () {
      if (!this.cardOptions.listItems) return []
      if (this.cardOptions.listItems.length > 5) return this.cardOptions.listItems.slice(0, 5)
      return this.cardOptions.listItems
    }
  },
  props: {
    cardOptions: {
      type: Object
    }
  }
}
</script>

<style scoped>
    .card-connections {
        border-radius: 10px;
        box-shadow: 0 3px 6px 0 rgba(0, 0, 0, 0.2);
        padding: 20px;
        min-height: 122px;
    }
    span.range {
      text-transform: capitalize;
    }
</style>
